import React from 'react';

const CHUNK_RELOAD_KEY = 'goldapi.chunkReloadAttempted';
const CHUNK_LOAD_ERROR_PATTERN = /ChunkLoadError|Loading chunk .+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i;

const isChunkLoadError = error => {
  if (!error) return false;
  return error.name === 'ChunkLoadError' || CHUNK_LOAD_ERROR_PATTERN.test(String(error.message || error));
};

const clearChunkReloadAttempt = () => {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch (err) {
    // The recovery screen remains available if session storage is blocked.
  }
};

const markChunkReloadAttempt = () => {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return false;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
    return true;
  } catch (err) {
    return false;
  }
};

export const lazyWithChunkRecovery = importer => React.lazy(() => importer()
  .then(module => {
    clearChunkReloadAttempt();
    return module;
  })
  .catch(error => {
    if (isChunkLoadError(error) && markChunkReloadAttempt()) {
      window.location.reload();
      return new Promise(() => {});
    }

    throw error;
  }));

class ChunkLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  reload = () => {
    clearChunkReloadAttempt();
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const chunkLoadFailed = isChunkLoadError(this.state.error);

    return (
      <div className="bg">
        <section className="mx-4 mx-md-5">
          <div className="vh-100">
            <div className="row h-100 justify-content-center align-items-center">
              <div className="col-12 col-md-7 col-lg-5 text-center">
                <h1 className="h3">{chunkLoadFailed ? 'GoldAPI.io has been updated' : 'GoldAPI.io could not be loaded'}</h1>
                <p className="text-muted my-3">
                  {chunkLoadFailed
                    ? 'The latest application files could not be loaded automatically. Reload the page to continue.'
                    : 'An unexpected application error occurred. Reload the page to try again.'}
                </p>
                <button type="button" className="btn btn-warning" onClick={this.reload}>Reload GoldAPI.io</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default ChunkLoadErrorBoundary;
